import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CircularArrows",
  "use": "CircularArrows-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" class=\"fizz-icon-24\" id=\"CircularArrows\">\n  <path d=\"M16 8.4v3.8l5.1-5.1L16 2v3.8C10.4 5.8 5.8 10.4 5.8 16c0 2 .6 3.9 1.6 5.4l1.9-1.9c-.6-1.1-.9-2.3-.9-3.6 0-4.1 3.4-7.5 7.6-7.5zm8.6 2.2l-1.9 1.9c.6 1.1.9 2.3.9 3.6 0 4.2-3.4 7.6-7.6 7.6v-3.8L10.9 25l5.1 5v-3.8c5.6 0 10.2-4.6 10.2-10.2 0-2-.6-3.9-1.6-5.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol